module.exports = __webpack_public_path__ + "static/media/468x60_0055_en.85f5295e.jpg";